"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskEffects = exports.RiskCauses = exports.RiskReferences = void 0;
var React = require("react");
var referenceList_1 = require("../references/referenceList");
var App_1 = require("../../App");
var generic_1 = require("../generic");
var buttons_1 = require("../buttons");
var causalityContainer_1 = require("../causalities/causalityContainer");
var utils_1 = require("../../utils");
var contexts_1 = require("../../interfaces/contexts");
var utils_2 = require("../references/utils");
var $ = require("jquery");
var RiskReferences = (function (_super) {
    __extends(RiskReferences, _super);
    function RiskReferences() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RiskReferences.prototype.onDeleteReference = function (ref) {
        fancyConfirm(gettext("Do you really want to delete the reference?"), function () {
            App_1.store.referenceDialog.deleteReference(ref).then(function () {
                notification(gettext("Reference has been successfully deleted"));
                App_1.store.riskPage.accordion.fetchReferences();
            });
        });
    };
    RiskReferences.prototype.render = function () {
        var props = this.props;
        return (React.createElement("div", null,
            React.createElement("div", { className: "RiskAccordion__ReferenceList" },
                React.createElement(generic_1.FloatRight, null,
                    React.createElement(buttons_1.ActionButton, { className: "btn-sm", buttonRef: function (button) {
                            bind_reference_dialog('div#risk_reference_dialog_bind');
                            $(button).off('click');
                            $(button).click(function (e) {
                                (0, utils_1.preventDefault)(e);
                                if (is_new_risk()) {
                                    notify_to_save_risk();
                                    return;
                                }
                                handleCreate(e, 'div#risk_reference_dialog_bind', "#risk_references_tab", "risk", function () { return props.risk_id; }, function () {
                                    var context = App_1.store.context.get();
                                    if (context instanceof contexts_1.ProjectContext) {
                                        $("#project_id").val(context.project);
                                        return context.project;
                                    }
                                    return null;
                                }, function () {
                                    App_1.store.riskPage.accordion.fetchReferences();
                                });
                            });
                        } },
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle }),
                        " ",
                        gettext("Create reference"))),
                React.createElement(referenceList_1.ReferenceList, { referredObject: utils_2.ReferenceListTypes.RISK, references: this.props.references, editable: true, deletable: true, onEditClick: App_1.store.referenceDialog.openDialog.bind(App_1.store.referenceDialog), onDeleteClick: this.onDeleteReference }))));
    };
    return RiskReferences;
}(React.Component));
exports.RiskReferences = RiskReferences;
var RiskCauses = (function (_super) {
    __extends(RiskCauses, _super);
    function RiskCauses() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RiskCauses.prototype.render = function () {
        var props = this.props;
        return (React.createElement(causalityContainer_1.CausalityContainer, { isCause: true, causalities: props.causes, openDialog: props.openDialog }));
    };
    return RiskCauses;
}(React.Component));
exports.RiskCauses = RiskCauses;
var RiskEffects = (function (_super) {
    __extends(RiskEffects, _super);
    function RiskEffects() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RiskEffects.prototype.render = function () {
        var props = this.props;
        return (React.createElement(causalityContainer_1.CausalityContainer, { isCause: false, causalities: props.effects, openDialog: props.openDialog }));
    };
    return RiskEffects;
}(React.Component));
exports.RiskEffects = RiskEffects;
